import {
    Box, Flex,
    Heading, HStack,
    Tab, TabIndicator,
    Table, TabList, TabPanel, TabPanels,
    Tabs,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr, useDisclosure,
    useMediaQuery,
    VStack
} from "@chakra-ui/react";
import {PaginationRow, StyledButton} from "../../../components";
import {useState} from "react";
import {ReactComponent as Close} from "../../../assets/icons/close.svg";
import {ReactComponent as Add} from "../../../assets/icons/add.svg";
import {ReactComponent as Arrow} from "../../../assets/icons/arrow_down.svg";
import {ReactComponent as MenuButton} from "../../../assets/icons/menu_button.svg";
import {ReactComponent as Sort} from "../../../assets/icons/asc_desc.svg";
import {ReactComponent as Bitcoin} from "../../../assets/icons/bitcoin_icon.svg";
import {ReactComponent as Filter} from "../../../assets/icons/filter.svg";
import {SpotScreener} from "../../../helpers/data-jsons";
import {ScreenerFilterModal} from "../../../components/modals/screener/ScreenerFilterModal";

const Web = () => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    const [isSmallerThan1250] = useMediaQuery("(max-width: 1250px)")
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(8);

    const totalPages = Math.ceil(SpotScreener.length / itemsPerPage);
    const currentItems = SpotScreener.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <VStack
            color={'neutral.100'}
            w={'100%'}>
            <Box
                borderBottom={'0.8px solid'}
                borderColor={'neutral.1100'}
                p={'11px 0'}
                w={'100%'}
            >
                <Heading color={'neutral.100'} fontSize={'heading.3xl'}>Spot screener</Heading>
            </Box>
            <Tabs
                position='relative'
                variant='unstyled'
                w={'100%'}
                display={'flex'}
                flexDirection={'column'}
                gap={'16px'}
            >
                <Flex
                    gap={'24px'}
                    pt={'8px'}
                    pb={'8px'}
                    borderBottom={'0.8px solid'}
                    borderColor={'neutral.1100'}
                >
                    <TabList gap={'16px'} display={'flex'}>
                        <Tab
                            pt={'4px'}
                            pb={'4px'}
                            pl={'8px'}
                            pr={'4px'}
                            minW={'55px'}
                            h={'32px'}
                            gap={'4px'}
                            color={'neutral.500'}
                            fontSize={'12px'}
                            border={'1px solid'}
                            borderColor={'neutral.900'}
                            borderRadius={'6px'}>
                            Tab1
                            <Close/>
                        </Tab>
                        <Tab
                            pt={'4px'}
                            pb={'4px'}
                            pl={'8px'}
                            h={'32px'}
                            minW={'55px'}
                            gap={'4px'}
                            color={'neutral.500'}
                            fontSize={'12px'}
                            pr={'4px'}
                            border={'1px solid'}
                            borderColor={'neutral.900'}
                            borderRadius={'6px'}
                        >Tab2<Close/></Tab>
                        <Tab
                            pt={'4px'}
                            pb={'4px'}
                            h={'32px'}
                            pl={'8px'}
                            minW={'55px'}
                            gap={'4px'}
                            color={'neutral.500'}
                            fontSize={'12px'}
                            pr={'4px'}
                            border={'1px solid'}
                            borderColor={'neutral.900'}
                            borderRadius={'6px'}
                        >Tab3<Close/></Tab>
                        <Tab
                            minW={'34px'}
                            h={'32px'}
                            p={'12px 10px'}
                            gap={'4px'}
                            color={'neutral.500'}
                            fontSize={'12px'}
                            border={'1px solid'}
                            borderColor={'neutral.900'}
                            borderRadius={'6px'}
                        ><Add/>
                        </Tab>
                    </TabList>
                    <Flex w={'full'} justifyContent={'space-between'}>
                        <StyledButton
                            leftIcon={<Filter width={'14px'} height={'14px'} m={'0'}/>}
                            bg={'neutral.900'}
                            onClick={onOpen}
                            h={'32px'}
                            w={'max-content'}
                            p={'16px 12px'}
                            gap={'4px'}
                            fontSize={'12px'}
                            textColor={'neutral.200'}
                        >
                            Filter
                        </StyledButton>
                        <ScreenerFilterModal
                            isOpen={isOpen}
                            onClose={onClose}
                        />
                        <StyledButton
                            h={'32px'}
                            bg={'neutral.900'}
                            p={'12px 16px'}
                            gap={'4px'}
                            rightIcon={<Arrow width={'14px'} height={'14px'}/>}
                            fontSize={'12px'}
                            textColor={'neutral.200'}
                        >
                            Templates
                        </StyledButton>
                    </Flex>
                </Flex>
                <TabIndicator mt='-1.5px' height='2px' bg='blue.500' borderRadius='1px'/>
                <Box
                    bg={'neutral.1100'}
                    borderRadius={'16px'}
                    pt={'16px'}
                    pr={'16px'}
                    pl={'16px'}
                    gap={'24px'}
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Flex
                        display={'flex'}
                        gap={'24px'}
                    >
                        <StyledButton
                            bg={'neutral.900'}
                            p={'8px 6px'}
                            w={'32px'}
                            h={'32px'}
                        ><MenuButton/></StyledButton>
                        <StyledButton
                            h={'32px'}
                            bg={'neutral.900'}
                            p={'12px 16px'}
                            gap={'4px'}
                            rightIcon={<Arrow width={'14px'} height={'14px'}/>}
                            fontSize={'12px'}
                            textColor={'neutral.200'}
                        >
                            15 seconds
                        </StyledButton>
                    </Flex>
                    <TabPanels
                        w={'full'}
                    >
                        <TabPanel p={'0'}>
                            <Box
                                w={'full'}
                                overflowY="auto"
                            >

                                <Table
                                    variant='unstyled'
                                    display={'flex'}
                                    flexDirection={'column'}
                                >
                                    <Thead
                                        display={'flex'}
                                        alignItems={'center'}
                                        h={'50px'}
                                        bg={'neutral.900'}
                                        borderRadius={'8px'}
                                    >
                                        <Tr
                                            display={'grid'}
                                            gridTemplateColumns={'9% 9% 7% 8% 9% 8% 18% 18% 14%'}
                                            fontSize={'body.sm'}
                                            w={'full'}
                                            justifyContent={'space-around'}
                                            alignItems={'center'}
                                        >
                                            <Th
                                                maxW={'144px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                gap={'4px'}
                                                fontSize={'14px'}
                                                fontFamily={'IBM Plex Sans'}
                                                fontWeight={'400'}
                                                textTransform={'none'}
                                                color={'neutral.600'}>
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}
                                                    >Currency pair<Sort/></Box>

                                                </HStack>

                                            </Th>
                                            <Th
                                                maxW={'127px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                textTransform={'none'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Sell exchange<Sort/></Box>

                                                </HStack>
                                            </Th>
                                            <Th
                                                maxW={'127px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Lifetime<Sort/></Box>

                                                </HStack>
                                            </Th>
                                            <Th
                                                maxW={'127px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Volume<Sort/></Box>

                                                </HStack>
                                            </Th>
                                            <Th
                                                maxW={'127px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Buy exchange<Sort/></Box>

                                                </HStack>
                                            </Th>
                                            <Th
                                                maxW={'127px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Profit<Sort/></Box>

                                                </HStack></Th>
                                            <Th
                                                maxW={'265px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Networks for withdrawal<Sort/></Box>

                                                </HStack></Th>
                                            <Th
                                                maxW={'265px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Networks for deposit<Sort/></Box>

                                                </HStack></Th>
                                            <Th
                                                maxW={'265px'}
                                                display={'flex'}
                                                flexDirection={'row'}
                                                justifyContent={'flex-start'}
                                                p={'8px 0'}
                                                textTransform={'none'}
                                                fontSize={'14px'}
                                                fontWeight={'400'}
                                                color={'neutral.600'}
                                            >
                                                <HStack>
                                                    <Box
                                                        display={'flex'}
                                                        gap={'5px'}
                                                        justifyContent={'center'}>Hedging<Sort/></Box>
                                                </HStack></Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody
                                        overflowY={isSmallerThan1250 ? 'scroll' : 'unset'}>
                                        {currentItems.map((item) => (
                                            <Tr
                                                padding={'12px 0'}
                                                display={'grid'}
                                                gridTemplateColumns={'9% 8% 7% 8% 7% 10% 15% 15% 15%'}
                                                key={item.id}
                                                h={'76px'}
                                                w={'full'}>
                                                <Td p={'0'}
                                                    maxW={'144px'}>
                                                    <Flex
                                                        alignItems={'flex-start'}
                                                        gap={'16px'}
                                                    >
                                                        <Bitcoin width={'32px'} height={'32px'}/>
                                                        <VStack
                                                            gap={'8px'}
                                                            alignItems={'flex-start'}
                                                        >
                                                            <Text
                                                                fontSize={'body.lg'}>
                                                                {item.pair}
                                                            </Text>
                                                            <Text
                                                                color={'neutral.500'}
                                                                fontSize={'body.xs'}>{item.coin}
                                                            </Text>
                                                        </VStack>
                                                    </Flex>
                                                </Td>
                                                <Td p={'0 8px'} maxW={'127px'}>
                                                    <Text
                                                        fontSize={'body.lg'}
                                                        color={'purple.400'}
                                                        textDecoration={'underline'}
                                                    >{item.exchange}</Text>
                                                    <Text color={'neutral.500'}
                                                          fontSize={'body.sm'}
                                                    >
                                                        {item.sellPrice}
                                                    </Text>
                                                </Td>
                                                <Td p={'0 8px'} maxW={'127px'}>
                                                    <Text
                                                        fontSize={'body.lg'}
                                                        color={'neutral.500'}
                                                    >
                                                        {item.lifeTime
                                                        }</Text>
                                                </Td>
                                                <Td p={'0 8px'} color={'neutral.500'} maxW={'127px'}>
                                                    <Text fontSize={'body.lg'}>{item.volume}</Text>
                                                    <Text color={'neutral.500'}
                                                          fontSize={'body.sm'}>{item.volumePrice}</Text>
                                                </Td>
                                                <Td p={'0 8px'} color={'neutral.500'} maxW={'127px'}>
                                                    <Text fontSize={'body.lg'}
                                                          color={'purple.400'}
                                                          textDecoration={'underline'}>{item.exchange}</Text>
                                                    <Text color={'neutral.500'}
                                                          fontSize={'body.sm'}>{item.buy}</Text>
                                                </Td>
                                                <Td p={'0 8px'} maxW={'127px'}>
                                                    <StyledButton
                                                        bg={'success.300'}
                                                        maxW={'76px'}
                                                        gap={'4px'}
                                                        fontSize={'body.xs'}
                                                        maxH={'24px'}
                                                        p={'6px 8px'}
                                                    >{item.profit}</StyledButton>
                                                </Td>
                                                <Td p={'0 8px'} maxW={'249px'}>
                                                    <Text fontSize={'body.md'}
                                                          color={'green.400'}>{item.networksWithdrawal}</Text>
                                                </Td>
                                                <Td p={'0 8px'} maxW={'249px'}>
                                                    <Text fontSize={'body.md'}
                                                          color={'green.400'}>{item.networksDeposit}</Text>
                                                </Td>
                                                <Td p={'0 8px'} maxW={'297px'}>
                                                    <Text fontSize={'body.md'}
                                                          textDecoration={'underline'}>{item.hedging}</Text>
                                                </Td>
                                            </Tr>

                                        ))}
                                    </Tbody>
                                </Table>
                                <Box pt={'12px'} pb={'16px'}>
                                    <PaginationRow
                                        pageCount={totalPages}
                                        onPageChange={setCurrentPage}
                                        itemsPerPage={itemsPerPage}
                                        onItemsPerPageChange={(newCount) => {
                                            setItemsPerPage(newCount);
                                            setCurrentPage(0);
                                        }}
                                    />
                                </Box>
                            </Box>
                        </TabPanel>
                    </TabPanels>
                </Box>
            </Tabs>

        </VStack>
    )
}
export default Web